import throttle from 'lodash.throttle';
/**
 * Sets the vh size via JS. This accounts for the little menu toolbars that
 * appear on a phone.
 *
 * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
 */
function setVhSize() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('resize', throttle(setVhSize, 500));

export default setVhSize;
